import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { NewWindowAnchor } from "@xo-union/component-standard-elements";
const cls2Styles = {
  fill: '#fff',
  stroke: '#fff',
  strokeMiterLimit: '10',
  strokeWidth: '.2px'
};
const cls9Styles = {
  isolation: 'isolate',
  opacity: '.12'
};
const GooglePlayBadge = props => /*#__PURE__*/React.createElement(NewWindowAnchor, _extends({
  href: "https://play.google.com/store/apps/details?id=com.xogrp.planner&hl=en_US"
}, props), /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: "31.8",
  y1: "183.29",
  x2: "15.02",
  y2: "166.51",
  gradientTransform: "matrix(1 0 0 -1 0 202)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#00a0ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".01",
  stopColor: "#00a1ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".26",
  stopColor: "#00beff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".51",
  stopColor: "#00d2ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".76",
  stopColor: "#00dfff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#00e3ff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: "43.83",
  y1: "172",
  x2: "19.64",
  y2: "172",
  gradientTransform: "matrix(1 0 0 -1 0 202)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#ffe000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".41",
  stopColor: "#ffbd00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".78",
  stopColor: "orange"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#ff9c00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: "34.83",
  y1: "169.7",
  x2: "12.07",
  y2: "146.95",
  gradientTransform: "matrix(1 0 0 -1 0 202)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#ff3a44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#c31162"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: "17.3",
  y1: "191.82",
  x2: "27.46",
  y2: "181.66",
  gradientTransform: "matrix(1 0 0 -1 0 202)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#32a071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".07",
  stopColor: "#2da771"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".48",
  stopColor: "#15cf74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".8",
  stopColor: "#06e775"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#00f076"
}))), /*#__PURE__*/React.createElement("rect", {
  width: "135",
  height: "40",
  rx: "5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140 10.8a4.2 4.2 0 0 1 4.2 4.2v30a4.2 4.2 0 0 1-4.2 4.2H15a4.2 4.2 0 0 1-4.2-4.2V15a4.2 4.2 0 0 1 4.2-4.2h125m0-.8H15a5 5 0 0 0-5 5v30a5 5 0 0 0 5 5h125a5 5 0 0 0 5-5V15a5 5 0 0 0-5-5z",
  transform: "translate(-10 -10)",
  fill: "#a6a6a6"
}), /*#__PURE__*/React.createElement("path", {
  style: cls2Styles,
  d: "M57.42 20.24a2.72 2.72 0 0 1-.75 2 2.9 2.9 0 0 1-2.2.88 3 3 0 0 1-2.21-.9 3.19 3.19 0 0 1 0-4.46 3.16 3.16 0 0 1 3.44-.65 2.54 2.54 0 0 1 .94.67l-.53.53a2 2 0 0 0-1.64-.72 2.4 2.4 0 1 0 1.68 4.13 1.92 1.92 0 0 0 .5-1.22h-2.18v-.72h2.91a3.75 3.75 0 0 1 .04.46zM62 17.74h-2.7v1.9h2.46v.72H59.3v1.9H62V23h-3.48v-6H62zM65.28 23h-.77v-5.26h-1.68V17H67v.74h-1.72zM69.94 23v-6h.77v6zM74.13 23h-.77v-5.26h-1.68V17h4.12v.74h-1.67zM83.61 22.22a3.11 3.11 0 0 1-4.4 0 3.24 3.24 0 0 1 0-4.44 2.93 2.93 0 0 1 2.2-.91 3 3 0 0 1 2.2.91 3.07 3.07 0 0 1 .88 2.22 3 3 0 0 1-.88 2.22zm-3.83-.5a2.29 2.29 0 0 0 3.26 0 2.54 2.54 0 0 0 0-3.44 2.29 2.29 0 0 0-3.26 0 2.54 2.54 0 0 0 0 3.44zM85.58 23v-6h.93l2.92 4.67V17h.77v6h-.8l-3.05-4.89V23z",
  transform: "translate(-10 -10)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.14 31.75A4.26 4.26 0 1 0 82.41 36a4.19 4.19 0 0 0-4.27-4.25zm0 6.83a2.58 2.58 0 1 1 2.4-2.58 2.46 2.46 0 0 1-2.4 2.58zm-9.32-6.83A4.26 4.26 0 1 0 73.09 36a4.19 4.19 0 0 0-4.27-4.25zm0 6.83a2.58 2.58 0 1 1 2.4-2.58 2.46 2.46 0 0 1-2.4 2.58zm-11.08-5.52v1.8h4.32a3.77 3.77 0 0 1-1 2.27 4.42 4.42 0 0 1-3.34 1.32 4.8 4.8 0 0 1 0-9.6A4.64 4.64 0 0 1 61 30.14l1.27-1.27a6.3 6.3 0 0 0-4.53-1.82 6.61 6.61 0 1 0 0 13.21 6.07 6.07 0 0 0 4.61-1.85 6 6 0 0 0 1.56-4.23 6.27 6.27 0 0 0-.09-1.12zm45.31 1.4a4 4 0 0 0-3.64-2.71 4 4 0 0 0-4 4.25 4.23 4.23 0 0 0 7.76 2.37l-1.45-1a2.41 2.41 0 0 1-2.09 1.17 2.15 2.15 0 0 1-2.06-1.29l5.69-2.35zm-5.8 1.42a2.34 2.34 0 0 1 2.23-2.49 1.64 1.64 0 0 1 1.57.91zM92.63 40h1.87V27.5h-1.87zm-3.06-7.3h-.07a2.94 2.94 0 0 0-2.24-1 4.26 4.26 0 0 0 0 8.51 2.88 2.88 0 0 0 2.24-1h.07v.61c0 1.63-.87 2.5-2.27 2.5a2.36 2.36 0 0 1-2.15-1.51l-1.62.67A4 4 0 0 0 87.3 44c2.19 0 4-1.29 4-4.43V32h-1.73zm-2.15 5.88a2.58 2.58 0 0 1 0-5.15A2.39 2.39 0 0 1 89.7 36a2.38 2.38 0 0 1-2.28 2.58zm24.39-11.08h-4.48V40h1.87v-4.74h2.61a3.89 3.89 0 1 0 0-7.76zm0 6h-2.61v-4.26h2.65a2.14 2.14 0 1 1 0 4.28zm11.54-1.79a3.49 3.49 0 0 0-3.33 1.91l1.65.69a1.78 1.78 0 0 1 1.71-.91 1.8 1.8 0 0 1 2 1.61v.12a4.18 4.18 0 0 0-1.95-.48c-1.78 0-3.6 1-3.6 2.82a2.89 2.89 0 0 0 3.11 2.75 2.65 2.65 0 0 0 2.38-1.22h.06v1h1.8v-4.81c0-2.19-1.66-3.46-3.79-3.46zm-.23 6.85c-.61 0-1.46-.31-1.46-1.06 0-1 1.06-1.34 2-1.34a3.32 3.32 0 0 1 1.7.42 2.26 2.26 0 0 1-2.2 2zM133.74 32l-2.14 5.42h-.06L129.32 32h-2l3.33 7.58-1.9 4.21h1.95L135.82 32zm-16.8 8h1.86V27.5h-1.86z",
  transform: "translate(-10 -10)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M20.44 17.54a2 2 0 0 0-.47 1.4v22.12a1.94 1.94 0 0 0 .47 1.4l.07.08L32.9 30.15v-.3L20.51 17.47z",
  transform: "translate(-10 -10)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37 34.28l-4.1-4.13v-.3l4.1-4.13.09.06L42 28.56c1.4.79 1.4 2.09 0 2.89l-4.89 2.78z",
  transform: "translate(-10 -10)",
  fill: "url(#linear-gradient-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.12 34.22L32.9 30 20.44 42.46a1.62 1.62 0 0 0 2.07.07l14.61-8.31",
  transform: "translate(-10 -10)",
  fill: "url(#linear-gradient-3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.12 25.78l-14.61-8.3a1.61 1.61 0 0 0-2.07.06L32.9 30z",
  transform: "translate(-10 -10)",
  fill: "url(#linear-gradient-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37 34.13l-14.49 8.25a1.66 1.66 0 0 1-2 0l-.07.07.07.08a1.66 1.66 0 0 0 2 0l14.61-8.31z",
  transform: "translate(-10 -10)",
  style: {
    isolation: 'isolate'
  },
  opacity: ".2"
}), /*#__PURE__*/React.createElement("path", {
  style: cls9Styles,
  d: "M20.44 42.32a2 2 0 0 1-.44-1.41v.15a1.94 1.94 0 0 0 .47 1.4l.07-.07zM42 31.3l-5 2.83.09.09L42 31.44A1.75 1.75 0 0 0 43.06 30 1.86 1.86 0 0 1 42 31.3z",
  transform: "translate(-10 -10)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.51 17.62L42 28.7a1.86 1.86 0 0 1 1.06 1.3A1.75 1.75 0 0 0 42 28.56L22.51 17.48c-1.39-.8-2.54-.14-2.54 1.46v.15c.03-1.6 1.15-2.26 2.54-1.47z",
  transform: "translate(-10 -10)",
  style: {
    isolation: 'isolate'
  },
  opacity: ".25",
  fill: "#fff"
}))));
process.env.NODE_ENV !== "production" ? GooglePlayBadge.propTypes = {
  className: PropTypes.string
} : void 0;
export default GooglePlayBadge;